
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M60.359 56.14c-3.098-1.865-12.62-3.562-14.226-6.615-.574-1.301-.689-2.15-.689-2.15s1.893-1.64 2.582-5.71c1.032.395 1.147-.566 1.204-1.697.058-1.131 1.205-2.771.976-3.676-.23-.905-.918-.792-.918-.792s.918-7.973-2.237-11.48c-2.295-2.544-5.335-2.77-7.343-2.77s-5.163.283-7.4 3.054c-2.983 3.675-2.18 11.196-2.18 11.196s-.688-.113-.917.792c-.23.905.918 2.545.975 3.676.057 1.13.172 2.092 1.204 1.696.632 4.072 2.582 5.712 2.582 5.712s-.115.848-.689 2.149C31.62 52.578 22.098 54.275 19 56.14","fill":"none","stroke-width":"2","stroke-linejoin":"round"}})])
          )
        }
      }
    